export default __webpack_public_path__ + "static/media/img_fee_65.46bb6608.svg";